import Link from 'next/link';
import styled from 'styled-components';
import { colors } from 'constants/theme';
export const Card = styled.article.withConfig({
  displayName: "articlecss__Card",
  componentId: "sc-u5cfl8-0"
})(["&:first-child{margin-top:19px;}padding-bottom:39px;&:not(:last-child){margin-bottom:29px;border-bottom:1px solid #e8e8e8;}"]);
export const SLink = styled(Link).withConfig({
  displayName: "articlecss__SLink",
  componentId: "sc-u5cfl8-1"
})(["width:100%;text-decoration:none;"]);
export const Row = styled.div.withConfig({
  displayName: "articlecss__Row",
  componentId: "sc-u5cfl8-2"
})(["width:100%;display:inline-flex;"]);
export const Thumb = styled.div.withConfig({
  displayName: "articlecss__Thumb",
  componentId: "sc-u5cfl8-3"
})(["position:relative;box-shadow:-1px 3px 6px 1px rgba(0,0,0,0.3);transition:all 0.2s ease-in-out;cursor:pointer;line-height:0;img{width:100%;height:auto;transition:transform 2s;}:hover{box-shadow:-2px 5px 8px 2px rgba(0,0,0,0.3);img{transform:scale(1.02);}}margin:0rem;"]);
export const Title = styled.h3.withConfig({
  displayName: "articlecss__Title",
  componentId: "sc-u5cfl8-4"
})(["margin-bottom:1rem;color:", ";display:inline-block;"], colors.black);
export const Description = styled.p.withConfig({
  displayName: "articlecss__Description",
  componentId: "sc-u5cfl8-5"
})(["text-decoration:none;color:", ";"], colors.black);